import Vue from "vue";

// styles

import "@fortawesome/fontawesome-free/css/all.min.css";
// import "@/assets/styles/tailwind.css";
import vuetify from '@/plugins/vuetify' // path to vuetify export
import moment from "moment";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueCryptojs from 'vue-cryptojs'
 
Vue.use(VueCryptojs);
Vue.use(VueSweetalert2);

// mouting point for the whole app

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

Vue.config.productionTip = false
Vue.prototype.$moment = moment

new Vue({
  router,
  store, vuetify,
  render: h => h(App),
}).$mount('#app');
